module.exports = __webpack_public_path__ + "img/banner-search.78c3585d.png";